import { createReducer } from '@reduxjs/toolkit';
import { Nullable } from 'modules/types/common';
import * as specialtiesActions from 'store/amwell/activeConsumer/specialties/actions';
import * as storageActions from 'store/amwell/storage/actions';
import * as visitActions from 'store/amwell//visit/actions';
import * as visitContextActions from 'store/amwell/visitContext/actions';

import { EstimatedVisitCost, ProviderDetails, Provider } from './types';
import * as actions from './actions';
import { RESET_AMWELL_ACTIVITY } from '../actions';

export type ProvidersState = Readonly<{
  list: {
    data: Provider[];
    loading: boolean;
    error: Nullable<Error>;
  };
  details: {
    data: Nullable<ProviderDetails>;
    providerDetailsWereViewed: boolean;
    estimatedVisitCost: Nullable<EstimatedVisitCost>;
    loading: { data: boolean; estimatedVisitCost: boolean };
    errors: { data: Nullable<Error>; estimatedVisitCost: Nullable<Error> };
  };
}>;

export const providersInitialState: ProvidersState = {
  list: {
    data: [],
    loading: false,
    error: null
  },
  details: {
    data: null,
    estimatedVisitCost: null,
    providerDetailsWereViewed: false,
    loading: { data: false, estimatedVisitCost: false },
    errors: { data: null, estimatedVisitCost: null }
  }
};

export const providersReducer = createReducer(providersInitialState, {
  [actions.GET_PROVIDERS_FOR_PRACTICE]: state => {
    state.list.loading = true;
    state.list.error = null;
  },
  [actions.GET_PROVIDERS_FOR_PRACTICE_FAIL]: (state, action) => {
    state.list.error = action.error;
    state.list.loading = false;
  },
  [actions.GET_PROVIDERS_FOR_PRACTICE_SUCCESS]: (state, action) => {
    state.list.data = action.payload;
    state.list.loading = false;
  },
  [actions.GET_PROVIDER_DETAIL]: state => {
    state.details.errors.data = null;
    state.details.loading.data = true;
  },
  [actions.GET_PROVIDER_DETAIL_FAIL]: (state, action) => {
    state.details.errors.data = action.error;
    state.details.loading.data = false;
  },
  [actions.GET_PROVIDER_DETAIL_SUCCESS]: (state, action) => {
    state.details.data = action.payload;
    state.details.loading.data = false;
  },
  [actions.SET_PROVIDER_DETAILS_WERE_VIEWED]: (state, action) => {
    state.details.providerDetailsWereViewed = action.payload;
  },
  [actions.GET_ESTIMATED_VISIT_COST]: state => {
    state.details.errors.estimatedVisitCost = null;
    state.details.loading.estimatedVisitCost = true;
  },
  [actions.GET_ESTIMATED_VISIT_COST_FAIL]: (state, action) => {
    state.details.errors.estimatedVisitCost = action.error;
    state.details.loading.estimatedVisitCost = false;
  },
  [actions.GET_ESTIMATED_VISIT_COST_SUCCESS]: (state, action) => {
    state.details.estimatedVisitCost = action.payload;
    state.details.loading.estimatedVisitCost = false;
  },
  [visitActions.TRANSFER_VISIT_SUCCESS]: (state, action) => {
    state.details.data = action.payload.provider;
  },
  [visitContextActions.CREATE_VISIT_CONTEXT_WITH_APPOINTMENT_SUCCESS]: (state, action) => {
    state.details.data = action.payload.provider;
  },
  [specialtiesActions.GET_FIRST_AVAILABLE_SUCCESS]: state => {
    state.details.data = null;
    state.details.estimatedVisitCost = null;
  },
  // Web Amwell Session Restore
  [storageActions.GET_STORAGE_SUCCESS]: (state, action) => {
    state.details.data = action.payload.provider;
  },
  [RESET_AMWELL_ACTIVITY]: () => providersInitialState
});
